const STATUS = Object.freeze({
  EM_VALIDACAO: 'Em validação',
  INVALIDO: 'Inválido',
  PRONTO_PARA_PROCESSAMENTO: 'Pronto para processamento',
  EM_PROCESSAMENTO: 'Em processamento',
  PROCESSADO: 'Processado',
  EM_CANCELAMENTO: 'Em cancelamento',
  CANCELADO: 'Cancelado',
  FALHOU: 'Falhou'
});

export default STATUS;